var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-results-container"},[_c('div',[_vm._v(" To continue, load the following game file using the green File Load button above: ")]),_c('div',{staticClass:"fileName"},[_vm._v(" "+_vm._s(_vm.fileName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }